import React from 'react';
import { SSOV2 } from '../../components';

export default function ViewSSOV2(props) {
  return <SSOV2 {...props} />;
}
